import { useState, useCallback } from 'react';
import {
  createDiagnosticOrder,
  submitDiagnosticOrder,
} from '../services/subscriberWalletService';

export const useDiagnosticOrder = (currentRole) => {
  const [orderId, setOrderId] = useState(null);
  const [orderNumber, setOrderNumber] = useState('');
  const [orderStatus, setOrderStatus] = useState(null);
  const [zone, setZone] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const createOrder = useCallback(async (orderData, showNotification) => {
    try {
      const response = await createDiagnosticOrder(currentRole, orderData);
      if (response?.metadata?.api_status === true) {
        const msg = response.msg;
        setOrderId(msg.order_id);
        setOrderNumber(msg.order_number || '');
        setOrderStatus(msg.status);
        setZone(msg.zone || '');
        return msg.order_id;
      } else {
        throw new Error(response?.msg?.error || 'Failed to create diagnostic order');
      }
    } catch (error) {
      showNotification(error.message || 'Failed to create diagnostic order', 'error');
      return null;
    }
  }, [currentRole]);

  const submitOrder = useCallback(async (showNotification) => {
    if (!orderId) {
      showNotification('No order to submit', 'error');
      return false;
    }
    setSubmitting(true);
    try {
      const response = await submitDiagnosticOrder(currentRole, orderId);
      if (response?.metadata?.api_status === true) {
        setOrderStatus('initiated');
        if (response.msg?.order_number) setOrderNumber(response.msg.order_number);
        showNotification('Diagnostic order submitted successfully!', 'success');
        return true;
      } else {
        throw new Error(response?.msg?.error || 'Failed to submit order');
      }
    } catch (error) {
      showNotification(error.message || 'Failed to submit order', 'error');
      return false;
    } finally {
      setSubmitting(false);
    }
  }, [currentRole, orderId]);

  return {
    orderId,
    setOrderId,
    orderNumber,
    setOrderNumber,
    orderStatus,
    setOrderStatus,
    zone,
    setZone,
    submitting,
    createOrder,
    submitOrder,
  };
};
